import { Path, Rect } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const HiddenEye: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Rect 
      x="16.582" 
      y="2.12891" 
      width="1.82301" 
      height="20.4398" 
      rx="0.911506" 
      transform="rotate(45 16.582 2.12891)" 
      fillRule="evenodd" 
    />
    <Path clipRule="evenodd" d="M12.223 4.96446C11.868 4.88145 11.5036 4.82381 11.1298 4.7944C10.3781 4.73524 9.62201 4.73524 8.87024 4.7944C5.65657 5.04729 3.13775 7.38692 1.25006 10C2.07189 11.1377 3.01334 12.2235 4.07968 13.1078L6.34504 10.8425C6.28287 10.5717 6.25003 10.2897 6.25003 10C6.25003 7.92895 7.92896 6.25002 10 6.25002C10.2897 6.25002 10.5717 6.28286 10.8425 6.34502L12.223 4.96446ZM9.15752 13.655C9.42834 13.7172 9.71035 13.75 10 13.75C12.0711 13.75 13.75 12.0711 13.75 10C13.75 9.71034 13.7172 9.42833 13.655 9.15751L15.9204 6.89216C16.9867 7.77652 17.9282 8.86235 18.75 10C16.8623 12.6131 14.3435 14.9528 11.1298 15.2056C10.3781 15.2648 9.62202 15.2648 8.87026 15.2056C8.49646 15.1762 8.13206 15.1186 7.77696 15.0356L9.15752 13.655Z" fillRule="evenodd" /> 

  </CustomIcon>
);

export default HiddenEye;